import nimg1 from "../images/depertment-single/neuro/1.jpg";
import nimg2 from "../images/depertment-single/neuro/2.jpg";
import nimg3 from "../images/depertment-single/neuro/3.jpg";

import uimg1 from "../images/depertment-single/urology/1.jpg";
import uimg2 from "../images/depertment-single/urology/2.jpg";
import uimg3 from "../images/depertment-single/urology/3.jpg";

import aimg1 from "../images/depertment-single/allergy/1.jpg";
import aimg2 from "../images/depertment-single/allergy/2.jpg";
import aimg3 from "../images/depertment-single/allergy/3.jpg";

import sIcon1 from "../images/department/1.png";
import sIcon2 from "../images/department/2.png";
import sIcon3 from "../images/department/3.png";

const Services = [
  {
    id: "1",
    title: "Dificuldade de Aprendizagem",
    slug: "dificuldade-de-aprendizagem",
    description:
      "Quis ipsome suspendisse ultrices gravid. Risus commod viverra maescums.",
    Icon: sIcon1,
    ssImg: nimg1,
    ssImg2: nimg2,
    ssImg3: nimg3,
  },
  {
    id: "2",
    title: "Plano de Intervenção Psicoeducacional ",
    slug: "urology",
    description:
      "Quis ipsome suspendisse ultrices gravid. Risus commod viverra maescums.",
    Icon: sIcon2,
    ssImg: uimg1,
    ssImg2: uimg2,
    ssImg3: uimg3,
  },
  {
    id: "3",
    title: "Treinamento Parental",
    slug: "Allergy",
    description:
      "Quis ipsome suspendisse ultrices gravid. Risus commod viverra maescums.",
    Icon: sIcon3,
    ssImg: aimg1,
    ssImg2: aimg2,
    ssImg3: aimg3,
  },
];
export default Services;
